import { render, staticRenderFns } from "./AdminMenuNavbarAction.vue?vue&type=template&id=351005d6&scoped=true"
import script from "./AdminMenuNavbarAction.vue?vue&type=script&lang=js"
export * from "./AdminMenuNavbarAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351005d6",
  null
  
)

export default component.exports